export default __webpack_public_path__ + "static/media/project-wizard-patient-properties_dark.315b198c.png";